import axios from "axios";
import { useMemo, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";

const QuestionRegenerateForm = ({ id, type, onSubmit: onSubmitCallback }) => {
  const [generateQuestion, setGenerateQuestion] = useState(false);
  const [questionsCount, setQuestionsCount] = useState([]);
  const [questionArray, setQuestionsArray] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [generating, setGenerating] = useState(false);

  const getAllQuestions = () => {
    const apiUrl = `${process.env.REACT_APP_API_URL}/scribe-bot-settings`;
    axios
      .get(apiUrl)
      .then((response) => {
        const questions = response.data.data
          .filter((item) => item.is_question === 1)
          .sort((a, b) => a.id - b.id)
          .map((item) => ({
            value: item.id,
            label: item.content_type,
          }));

        setQuestionsArray(questions);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleCountChange = (id, value) => {
    setQuestionsCount((prev) => {
      const exists = prev.find((q) => q.id === id);
      if (exists) {
        return prev.map((q) => (q.id === id ? { ...q, count: value } : q));
      } else {
        return [...prev, { id, count: value }];
      }
    });
  };

  const [title, description, checkbox] = useMemo(() => {
    switch (type) {
      case "new":
        return [
          "No Questions Available",
          "There are currently no questions linked to the selected video",
          "Would you like to re-generate relevant questions based on the course content?",
        ];
      case "partial":
        return [
          "Partial Question Match",
          "Some existing questions may no longer align with the updated course content",
          "Do you want to regenerate all questions to improve relevancy?",
        ];
      case "complete":
        return [
          "All questions are relevant",
          "",
          "Do you still want to regenerate the questions?",
        ];
      case "none":
        return [
          "No relevant questions available",
          "There are currently no relevant questions linked to the selected video",
          "Would you like to re-generate relevant questions based on the course content?",
        ];
    }
  }, [type]);

  const onSubmit = () => {
    if (questionsCount.some((q) => q.count > 20)) {
      toast.error("Question count cannot exceed 20.");
      return;
    }

    setGenerating(true);
    const fullname = localStorage.getItem("fullname");
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/video-finder-question-generation`,
        {
          id,
          fullname,
          question_details: questionsCount,
        }
      )
      .then(() => {
        toast.success("Questions regeneratiton started successfully.");
        onSubmitCallback?.();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error regenerating questions.");
      })
      .finally(() => {
        setGenerating(false);
      });
  };

  return (
    <div className="mt-4">
      <h6>{title}</h6>
      {!!description && <div>{description}</div>}
      <Form.Group className="pb-2" controlId="generate-question">
        <Form.Check
          type="checkbox"
          id="generate-question-chk"
          style={{ textAlign: "left", marginTop: "12px", marginBottom: "8px" }}
          label={checkbox}
          checked={generateQuestion}
          onChange={(e) => setGenerateQuestion(e.target.checked)}
        />
        {generateQuestion && (
          <>
            <Form style={{ width: "100%" }}>
              <Row>
                <Col lg={6} sm={12}>
                  <Form.Group controlId="" className="mb-2">
                    <div className="d-flex">
                      <label className="me-3" style={{ whiteSpace: "nowrap" }}>
                        Question Type:
                      </label>
                      <div className="position-relative">
                        <Select
                          options={questionArray}
                          placeholder="Select questions"
                          isClearable
                          isSearchable
                          isMulti
                          value={questions}
                          onMenuOpen={getAllQuestions}
                          noOptionsMessage={() => "No options available"}
                          onChange={(selectedOptions) => {
                            setQuestions(selectedOptions);
                            setQuestionsCount((prev) =>
                              prev.filter((q) =>
                                selectedOptions?.some(
                                  (opt) => opt.value === q.id
                                )
                              )
                            );
                          }}
                        />
                      </div>
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={6} sm={12}>
                  {questions.map((item, index) => {
                    const currentCount =
                      questionsCount.find((q) => q.id === item.value)?.count ||
                      "";
                    return (
                      <div
                        key={item.value}
                        className="d-flex align-items-center mb-2"
                      >
                        <label
                          className="me-3 mb-0"
                          style={{ minWidth: "170px", textAlign: "left" }}
                        >
                          {item.label}
                        </label>
                        <Form.Control
                          type="number"
                          placeholder="NO."
                          min={1}
                          max={20}
                          style={{ maxWidth: "70px", marginLeft: "20px" }}
                          value={currentCount}
                          onChange={(e) =>
                            handleCountChange(item.value, e.target.value)
                          }
                          className="w-20"
                        />
                      </div>
                    );
                  })}
                </Col>
              </Row>
            </Form>
            <Button
              variant="primary"
              onClick={onSubmit}
              disabled={
                generating ||
                questions.length === 0 ||
                questionsCount.length !== questions.length ||
                questionsCount.some((q) => !q.count || q.count <= 0)
              }
            >
              {generating ? "Regenerating..." : "Regenerate"}
            </Button>
          </>
        )}
      </Form.Group>
    </div>
  );
};

export default QuestionRegenerateForm;
